
export default [{
	path: '/admin-apps',
	component: () => import('@/components/admin_apps/AppList')
}]
